// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var RetryCount = function (x) {
    return x;
};
var tsBridgeRetryCount = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("RetryCount")("__brandRetryCount"));
    }
};
var writeRetryCount = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showRetryCount = Data_Show.showNumber;
var readRetryCount = Simple_JSON.readNumber;
var ordRetryCount = Data_Ord.ordNumber;
var newtypeRetryCount = {
    Coercible0: function () {
        return undefined;
    }
};
var makeRetryCount = RetryCount;
var eqRetryCount = Data_Eq.eqNumber;
export {
    RetryCount,
    makeRetryCount,
    unwrap,
    newtypeRetryCount,
    eqRetryCount,
    ordRetryCount,
    showRetryCount,
    readRetryCount,
    writeRetryCount,
    tsBridgeRetryCount
};
//# sourceMappingURL=index.js.map
